import { gql } from '@/__generated__';

export const activeProductsStock = gql(/* GraphQL */ `
  query ActiveProductsStock {
    activeProductsStock {
      id
      code
      name
      price
      variants {
        id
        stock
        attributes {
          id
          name
          value
        }
      }
    }
  }
`);
